import React, { useState } from 'react'
import { Collapse, Typography, Tag, Divider, Popover, Tabs } from 'antd'
import ProjectLogPopover from './projectLogPopover'
import dayjs from 'dayjs'
import ScreenShotList from './screenShotList'

const { Text } = Typography
const { Panel } = Collapse
const { TabPane } = Tabs

const msToHMS = (ms) => {
    const h = Math.floor(ms / 3600000)
    const m = Math.floor((ms % 3600000) / 60000)
    const s = Math.floor((ms % 60000) / 1000)
    return `${h}h ${m}m ${s}s`
}

const projectColors = [
    '#4F46E5', '#00C9A7', '#FFB020', '#EF4444', '#10B981',
    '#6366F1', '#F59E0B', '#3B82F6', '#8B5CF6', '#EC4899',
    '#F97316', '#22D3EE', '#A855F7', '#14B8A6', '#EAB308',
    '#06B6D4', '#D946EF', '#FB923C', '#4ADE80', '#F43F5E',
]

const getDayName = (dateString) => {
    const date = dayjs(dateString, 'DD-MM-YYYY')
    return date.isValid() ? date.format('dddd') : 'Invalid Date'
}

const ReportDrawerBody = ({ reportData = [], activeTab, setActiveTab, activeKey, setActiveKey, user }) => {


    const maxDuration = 8 * 60 * 60 * 1000 // 8 hours in ms

    return (
        <Tabs activeKey={activeTab} onChange={setActiveTab}>
            <TabPane tab="Time Log" key="time-log">
                {
                    reportData.length === 0 ? <div style={{ textAlign: 'center', padding: '40px 0' }}>
                        <Text strong style={{ fontSize: 16, color: '#999' }}>
                            No time logs available.
                        </Text>
                    </div> : <Collapse
                        accordion
                        bordered={false}
                        style={{ background: 'transparent' }}
                        expandIconPosition="end"
                        activeKey={activeKey}
                        onChange={(key) => setActiveKey(key)}
                    >
                        {reportData.map((day, index) => {
                            const isOpen = activeKey == index

                            return (
                                <Panel
                                    key={index}
                                    header={
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 }}>
                                            <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "self-start" }}>
                                                <Text style={{ fontWeight: "600", fontSize: "14px" }}>{getDayName(day.date)}</Text>
                                                <Text style={{ fontWeight: "600", color: "#00000073", fontSize: "12px" }}>{day.date}</Text>
                                            </div>

                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        width: 150,
                                                        height: 6,
                                                        borderRadius: 4,
                                                        overflow: 'hidden',
                                                        background: '#f0f0f0',
                                                        cursor: 'pointer',
                                                    }}
                                                >
                                                    {day.projects.map((project, pIdx) => {
                                                        const cappedDuration = Math.min(project.totalProjectDuration, maxDuration)
                                                        const percent = (cappedDuration / maxDuration) * 100

                                                        return (
                                                            <Popover
                                                                key={pIdx}
                                                                placement="top"
                                                                trigger="hover"
                                                                overlayInnerStyle={{ padding: 10, maxWidth: 400, minWidth: "365px" }}
                                                                content={<ProjectLogPopover project={project} />}
                                                            >
                                                                <div
                                                                    style={{
                                                                        width: `${percent}%`,
                                                                        backgroundColor: project?.colorCode ? project?.colorCode : projectColors[pIdx % projectColors.length],
                                                                        height: 6,
                                                                        minWidth: 2,
                                                                    }}
                                                                />
                                                            </Popover>
                                                        )
                                                    })}
                                                </div>

                                                <Text style={{ fontSize: 12, fontWeight: 600, marginTop: 2, color: "#00000073" }}>
                                                    {msToHMS(day.totalDateDuration)}
                                                </Text>
                                            </div>
                                        </div>
                                    }
                                    style={{
                                        background: '#fff',
                                        borderRadius: 12,
                                        marginBottom: 12,
                                        boxShadow: 'rgba(0, 0, 0, 0.05) 0px 0px 0px 1px',
                                        transition: 'box-shadow 0.3s ease',
                                    }}
                                >
                                    {day.projects.map((project, pi) => (
                                        <div key={pi} style={{ marginBottom: 16 }}>
                                            <Divider style={{ margin: '8px 0' }} />
                                            <div style={{ display: "flex", justifyContent: 'space-between', alignItems: 'center' }}>
                                                <Text style={{ fontSize: 15, fontWeight: 700 }}>
                                                    {project.projectName}
                                                </Text>
                                                {project.tasks.length > 1 && (
                                                    <Tag style={{ fontSize: 13, fontWeight: 700 }}>
                                                        {msToHMS(project.totalProjectDuration)}
                                                    </Tag>
                                                )}
                                            </div>
                                            <Divider style={{ margin: '8px 0' }} />

                                            {project.tasks.map((task, ti) => (
                                                <div
                                                    key={ti}
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        padding: '6px 12px',
                                                        marginBottom: 6,
                                                        background: '#fafafa',
                                                        borderRadius: 8,
                                                    }}
                                                >
                                                    <Text style={{ color: "#2e2e2eff" }}>{task.taskTitle}</Text>
                                                    <Tag
                                                        style={{
                                                            borderRadius: 8,
                                                            padding: '2px 10px',
                                                            cursor: 'auto',
                                                            color: "#2e2e2eff",
                                                            border: "1px solid",
                                                            borderColor: project?.colorCode ? project?.colorCode : projectColors[pi % projectColors.length],
                                                            background: "#fff"
                                                        }}
                                                    >
                                                        {msToHMS(task.totalTaskDuration)}
                                                    </Tag>
                                                </div>
                                            ))}
                                        </div>
                                    ))}
                                </Panel>
                            )
                        })}
                    </Collapse>
                }

            </TabPane>

            {/* <TabPane tab="Screenshot" key="screenshot">
                <div style={{ padding: 12 }}>
                    <ScreenShotList user={user} />
                </div>
            </TabPane> */}
        </Tabs>
    )
}

export default ReportDrawerBody
